import * as yup from 'yup';
import { MuxVideo } from '@web/components';
import { resolveVideoPosterUrl } from '../resolveVideoPosterUrl';

export const component = MuxVideo;

export const schema = yup
  .object({
    playbackId: yup.string().required(),
    thumbnail: yup.string().nullable(),
    autoplay: yup.bool(),
    loop: yup.bool(),
    component: yup.string(),
    aspectRatio: yup.string(),
  })
  .transform(value => {
    if (!value) {
      return null;
    }

    const playbackId = value.mux_asset.playback_ids[0].id;

    return {
      playbackId,
      thumbnail:
        resolveVideoPosterUrl(value.thumbnail) ||
        `https://image.mux.com/${playbackId}/thumbnail.png`,
      autoplay: value.autoplay,
      loop: value.loop,
      component: value.component || 'mux_video',
      aspectRatio: value.aspect_ratio || '4 / 3',
    };
  });
